module.exports = __webpack_public_path__ + "media/images/rails_lts-9045da5865d23a04123e7cd15bc71141.svg";